@file:OptIn(InternalResourceApi::class)

package retroguide.app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/retroguide.app.shared.generated.resources/"

@delegate:ResourceContentHash(-1_129_260_237)
internal val Res.string.action_item_due: StringResource by lazy {
      StringResource("string:action_item_due", "action_item_due", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 35),
      ))
    }

@delegate:ResourceContentHash(1_573_444_643)
internal val Res.string.action_item_what: StringResource by lazy {
      StringResource("string:action_item_what", "action_item_what", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46, 40),
      ))
    }

@delegate:ResourceContentHash(-140_413_723)
internal val Res.string.action_item_who: StringResource by lazy {
      StringResource("string:action_item_who", "action_item_who", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87, 47),
      ))
    }

@delegate:ResourceContentHash(1_282_243_439)
internal val Res.string.add_question_action: StringResource by lazy {
      StringResource("string:add_question_action", "add_question_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135, 51),
      ))
    }

@delegate:ResourceContentHash(-1_549_622_723)
internal val Res.string.answer_choice_title: StringResource by lazy {
      StringResource("string:answer_choice_title", "answer_choice_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187, 59),
      ))
    }

@delegate:ResourceContentHash(-799_938_955)
internal val Res.string.answer_edit_label: StringResource by lazy {
      StringResource("string:answer_edit_label", "answer_edit_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247, 49),
      ))
    }

@delegate:ResourceContentHash(-620_115_272)
internal val Res.string.answer_label: StringResource by lazy {
      StringResource("string:answer_label", "answer_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297, 40),
      ))
    }

@delegate:ResourceContentHash(1_521_145_927)
internal val Res.string.answer_placeholder: StringResource by lazy {
      StringResource("string:answer_placeholder", "answer_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338, 62),
      ))
    }

@delegate:ResourceContentHash(-1_348_701_421)
internal val Res.string.battery_answer_prompt: StringResource by lazy {
      StringResource("string:battery_answer_prompt", "battery_answer_prompt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 401, 69),
      ))
    }

@delegate:ResourceContentHash(-1_221_237_269)
internal val Res.string.battery_percent: StringResource by lazy {
      StringResource("string:battery_percent", "battery_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 471, 35),
      ))
    }

@delegate:ResourceContentHash(-1_055_289_304)
internal val Res.string.cancel_action: StringResource by lazy {
      StringResource("string:cancel_action", "cancel_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 507, 33),
      ))
    }

@delegate:ResourceContentHash(-605_179_749)
internal val Res.string.category_abyss: StringResource by lazy {
      StringResource("string:category_abyss", "category_abyss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 613, 34),
      ))
    }

@delegate:ResourceContentHash(-1_715_421_281)
internal val Res.string.category_abyss_hint: StringResource by lazy {
      StringResource("string:category_abyss_hint", "category_abyss_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 541, 71),
      ))
    }

@delegate:ResourceContentHash(2_499_327)
internal val Res.string.category_add: StringResource by lazy {
      StringResource("string:category_add", "category_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 718, 24),
      ))
    }

@delegate:ResourceContentHash(1_617_923_170)
internal val Res.string.category_add_hint: StringResource by lazy {
      StringResource("string:category_add_hint", "category_add_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 648, 69),
      ))
    }

@delegate:ResourceContentHash(962_519_765)
internal val Res.string.category_anchor: StringResource by lazy {
      StringResource("string:category_anchor", "category_anchor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 792, 31),
      ))
    }

@delegate:ResourceContentHash(160_028_959)
internal val Res.string.category_anchor_hint: StringResource by lazy {
      StringResource("string:category_anchor_hint", "category_anchor_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 743, 48),
      ))
    }

@delegate:ResourceContentHash(184_878_703)
internal val Res.string.category_answer_prompt: StringResource by lazy {
      StringResource("string:category_answer_prompt", "category_answer_prompt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 824, 58),
      ))
    }

@delegate:ResourceContentHash(1_789_192_769)
internal val Res.string.category_bridge: StringResource by lazy {
      StringResource("string:category_bridge", "category_bridge", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 952, 35),
      ))
    }

@delegate:ResourceContentHash(1_468_951_305)
internal val Res.string.category_bridge_hint: StringResource by lazy {
      StringResource("string:category_bridge_hint", "category_bridge_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 883, 68),
      ))
    }

@delegate:ResourceContentHash(-1_438_907_004)
internal val Res.string.category_continue: StringResource by lazy {
      StringResource("string:category_continue", "category_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1059, 37),
      ))
    }

@delegate:ResourceContentHash(-592_687_501)
internal val Res.string.category_continue_hint: StringResource by lazy {
      StringResource("string:category_continue_hint", "category_continue_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 988, 70),
      ))
    }

@delegate:ResourceContentHash(-1_412_138_624)
internal val Res.string.category_drop: StringResource by lazy {
      StringResource("string:category_drop", "category_drop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1152, 29),
      ))
    }

@delegate:ResourceContentHash(-1_919_910_362)
internal val Res.string.category_drop_hint: StringResource by lazy {
      StringResource("string:category_drop_hint", "category_drop_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1097, 54),
      ))
    }

@delegate:ResourceContentHash(1_949_750_463)
internal val Res.string.category_engine: StringResource by lazy {
      StringResource("string:category_engine", "category_engine", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1239, 31),
      ))
    }

@delegate:ResourceContentHash(-672_188_955)
internal val Res.string.category_engine_hint: StringResource by lazy {
      StringResource("string:category_engine_hint", "category_engine_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1182, 56),
      ))
    }

@delegate:ResourceContentHash(1_640_307_720)
internal val Res.string.category_fire: StringResource by lazy {
      StringResource("string:category_fire", "category_fire", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1322, 29),
      ))
    }

@delegate:ResourceContentHash(1_032_623_037)
internal val Res.string.category_fire_hint: StringResource by lazy {
      StringResource("string:category_fire_hint", "category_fire_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1271, 50),
      ))
    }

@delegate:ResourceContentHash(1_841_360_407)
internal val Res.string.category_glad: StringResource by lazy {
      StringResource("string:category_glad", "category_glad", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1419, 29),
      ))
    }

@delegate:ResourceContentHash(1_043_819_880)
internal val Res.string.category_glad_hint: StringResource by lazy {
      StringResource("string:category_glad_hint", "category_glad_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1352, 66),
      ))
    }

@delegate:ResourceContentHash(-595_974_556)
internal val Res.string.category_improve: StringResource by lazy {
      StringResource("string:category_improve", "category_improve", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1515, 36),
      ))
    }

@delegate:ResourceContentHash(-662_643_985)
internal val Res.string.category_improve_hint: StringResource by lazy {
      StringResource("string:category_improve_hint", "category_improve_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1449, 65),
      ))
    }

@delegate:ResourceContentHash(160_561_772)
internal val Res.string.category_island: StringResource by lazy {
      StringResource("string:category_island", "category_island", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1605, 31),
      ))
    }

@delegate:ResourceContentHash(644_272_390)
internal val Res.string.category_island_hint: StringResource by lazy {
      StringResource("string:category_island_hint", "category_island_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1552, 52),
      ))
    }

@delegate:ResourceContentHash(-1_680_225_485)
internal val Res.string.category_keep: StringResource by lazy {
      StringResource("string:category_keep", "category_keep", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1692, 29),
      ))
    }

@delegate:ResourceContentHash(-1_550_828_194)
internal val Res.string.category_keep_hint: StringResource by lazy {
      StringResource("string:category_keep_hint", "category_keep_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1637, 54),
      ))
    }

@delegate:ResourceContentHash(1_060_306_333)
internal val Res.string.category_lacked: StringResource by lazy {
      StringResource("string:category_lacked", "category_lacked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1775, 31),
      ))
    }

@delegate:ResourceContentHash(-1_797_946_803)
internal val Res.string.category_lacked_hint: StringResource by lazy {
      StringResource("string:category_lacked_hint", "category_lacked_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1722, 52),
      ))
    }

@delegate:ResourceContentHash(819_539_149)
internal val Res.string.category_learned: StringResource by lazy {
      StringResource("string:category_learned", "category_learned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1865, 36),
      ))
    }

@delegate:ResourceContentHash(910_725_111)
internal val Res.string.category_learned_hint: StringResource by lazy {
      StringResource("string:category_learned_hint", "category_learned_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1807, 57),
      ))
    }

@delegate:ResourceContentHash(1_533_274_155)
internal val Res.string.category_less: StringResource by lazy {
      StringResource("string:category_less", "category_less", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1965, 29),
      ))
    }

@delegate:ResourceContentHash(2_009_883_042)
internal val Res.string.category_less_hint: StringResource by lazy {
      StringResource("string:category_less_hint", "category_less_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1902, 62),
      ))
    }

@delegate:ResourceContentHash(-2_139_538_238)
internal val Res.string.category_liked: StringResource by lazy {
      StringResource("string:category_liked", "category_liked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2051, 30),
      ))
    }

@delegate:ResourceContentHash(553_022_155)
internal val Res.string.category_liked_hint: StringResource by lazy {
      StringResource("string:category_liked_hint", "category_liked_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1995, 55),
      ))
    }

@delegate:ResourceContentHash(-105_752_454)
internal val Res.string.category_longed_for: StringResource by lazy {
      StringResource("string:category_longed_for", "category_longed_for", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2151, 43),
      ))
    }

@delegate:ResourceContentHash(373_355_294)
internal val Res.string.category_longed_for_hint: StringResource by lazy {
      StringResource("string:category_longed_for_hint", "category_longed_for_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2082, 68),
      ))
    }

@delegate:ResourceContentHash(2_588_328)
internal val Res.string.category_mad: StringResource by lazy {
      StringResource("string:category_mad", "category_mad", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2253, 24),
      ))
    }

@delegate:ResourceContentHash(-351_294_727)
internal val Res.string.category_mad_hint: StringResource by lazy {
      StringResource("string:category_mad_hint", "category_mad_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2195, 57),
      ))
    }

@delegate:ResourceContentHash(2_016_957_626)
internal val Res.string.category_more: StringResource by lazy {
      StringResource("string:category_more", "category_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2337, 29),
      ))
    }

@delegate:ResourceContentHash(1_221_909_808)
internal val Res.string.category_more_hint: StringResource by lazy {
      StringResource("string:category_more_hint", "category_more_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2278, 58),
      ))
    }

@delegate:ResourceContentHash(-687_926_868)
internal val Res.string.category_parachute: StringResource by lazy {
      StringResource("string:category_parachute", "category_parachute", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2419, 42),
      ))
    }

@delegate:ResourceContentHash(160_028_959)
internal val Res.string.category_parachute_hint: StringResource by lazy {
      StringResource("string:category_parachute_hint", "category_parachute_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2367, 51),
      ))
    }

@delegate:ResourceContentHash(1_701_492_166)
internal val Res.string.category_rock: StringResource by lazy {
      StringResource("string:category_rock", "category_rock", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2525, 29),
      ))
    }

@delegate:ResourceContentHash(1_624_179_704)
internal val Res.string.category_rock_hint: StringResource by lazy {
      StringResource("string:category_rock_hint", "category_rock_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2462, 62),
      ))
    }

@delegate:ResourceContentHash(2_582_562)
internal val Res.string.category_sad: StringResource by lazy {
      StringResource("string:category_sad", "category_sad", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2617, 24),
      ))
    }

@delegate:ResourceContentHash(1_824_369_730)
internal val Res.string.category_sad_hint: StringResource by lazy {
      StringResource("string:category_sad_hint", "category_sad_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2555, 61),
      ))
    }

@delegate:ResourceContentHash(782_266_208)
internal val Res.string.category_sandbag: StringResource by lazy {
      StringResource("string:category_sandbag", "category_sandbag", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2700, 40),
      ))
    }

@delegate:ResourceContentHash(-831_309_071)
internal val Res.string.category_sandbag_hint: StringResource by lazy {
      StringResource("string:category_sandbag_hint", "category_sandbag_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2642, 57),
      ))
    }

@delegate:ResourceContentHash(-1_720_235_253)
internal val Res.string.category_start: StringResource by lazy {
      StringResource("string:category_start", "category_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2805, 30),
      ))
    }

@delegate:ResourceContentHash(-1_908_635_124)
internal val Res.string.category_start_hint: StringResource by lazy {
      StringResource("string:category_start_hint", "category_start_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2741, 63),
      ))
    }

@delegate:ResourceContentHash(-1_707_349_824)
internal val Res.string.category_stop: StringResource by lazy {
      StringResource("string:category_stop", "category_stop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2895, 29),
      ))
    }

@delegate:ResourceContentHash(1_462_251_368)
internal val Res.string.category_stop_hint: StringResource by lazy {
      StringResource("string:category_stop_hint", "category_stop_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2836, 58),
      ))
    }

@delegate:ResourceContentHash(-1_771_030_892)
internal val Res.string.category_storm: StringResource by lazy {
      StringResource("string:category_storm", "category_storm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2989, 30),
      ))
    }

@delegate:ResourceContentHash(158_508_489)
internal val Res.string.category_storm_hint: StringResource by lazy {
      StringResource("string:category_storm_hint", "category_storm_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2925, 63),
      ))
    }

@delegate:ResourceContentHash(983_474_732)
internal val Res.string.category_sun: StringResource by lazy {
      StringResource("string:category_sun", "category_sun", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3078, 28),
      ))
    }

@delegate:ResourceContentHash(1_440_510_313)
internal val Res.string.category_sun_hint: StringResource by lazy {
      StringResource("string:category_sun_hint", "category_sun_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3020, 57),
      ))
    }

@delegate:ResourceContentHash(-108_876_884)
internal val Res.string.category_wind: StringResource by lazy {
      StringResource("string:category_wind", "category_wind", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3158, 29),
      ))
    }

@delegate:ResourceContentHash(1_032_623_037)
internal val Res.string.category_wind_hint: StringResource by lazy {
      StringResource("string:category_wind_hint", "category_wind_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3107, 50),
      ))
    }

@delegate:ResourceContentHash(487_437_778)
internal val Res.string.cluster_create: StringResource by lazy {
      StringResource("string:cluster_create", "cluster_create", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3188, 42),
      ))
    }

@delegate:ResourceContentHash(114_442_426)
internal val Res.string.cluster_delete: StringResource by lazy {
      StringResource("string:cluster_delete", "cluster_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3231, 34),
      ))
    }

@delegate:ResourceContentHash(1_707_083_939)
internal val Res.string.cluster_mode_done: StringResource by lazy {
      StringResource("string:cluster_mode_done", "cluster_mode_done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3266, 33),
      ))
    }

@delegate:ResourceContentHash(2_108_974_257)
internal val Res.string.cluster_mode_start: StringResource by lazy {
      StringResource("string:cluster_mode_start", "cluster_mode_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3300, 46),
      ))
    }

@delegate:ResourceContentHash(-2_002_249_729)
internal val Res.string.cluster_name_label: StringResource by lazy {
      StringResource("string:cluster_name_label", "cluster_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3347, 46),
      ))
    }

@delegate:ResourceContentHash(1_002_589_861)
internal val Res.string.cluster_selection_hint: StringResource by lazy {
      StringResource("string:cluster_selection_hint", "cluster_selection_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3394, 114),
      ))
    }

@delegate:ResourceContentHash(1_226_263_241)
internal val Res.string.clusters_title: StringResource by lazy {
      StringResource("string:clusters_title", "clusters_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3509, 30),
      ))
    }

@delegate:ResourceContentHash(711_151_791)
internal val Res.string.create_retro_action: StringResource by lazy {
      StringResource("string:create_retro_action", "create_retro_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3540, 55),
      ))
    }

@delegate:ResourceContentHash(-1_092_947_114)
internal val Res.string.current_timer_label: StringResource by lazy {
      StringResource("string:current_timer_label", "current_timer_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3596, 75),
      ))
    }

@delegate:ResourceContentHash(1_640_836_158)
internal val Res.string.current_timer_supporting_text: StringResource by lazy {
      StringResource("string:current_timer_supporting_text", "current_timer_supporting_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3672, 93),
      ))
    }

@delegate:ResourceContentHash(-1_282_936_110)
internal val Res.string.delete_answer_action: StringResource by lazy {
      StringResource("string:delete_answer_action", "delete_answer_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3766, 40),
      ))
    }

@delegate:ResourceContentHash(1_397_866_920)
internal val Res.string.display_name_label: StringResource by lazy {
      StringResource("string:display_name_label", "display_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3807, 54),
      ))
    }

@delegate:ResourceContentHash(561_173_304)
internal val Res.string.display_name_placeholder: StringResource by lazy {
      StringResource("string:display_name_placeholder", "display_name_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3862, 60),
      ))
    }

@delegate:ResourceContentHash(-1_756_392_911)
internal val Res.string.dot_vote_add: StringResource by lazy {
      StringResource("string:dot_vote_add", "dot_vote_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3923, 52),
      ))
    }

@delegate:ResourceContentHash(843_115_939)
internal val Res.string.dot_vote_members: StringResource by lazy {
      StringResource("string:dot_vote_members", "dot_vote_members", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3976, 44),
      ))
    }

@delegate:ResourceContentHash(186_532_145)
internal val Res.string.dot_vote_no_options: StringResource by lazy {
      StringResource("string:dot_vote_no_options", "dot_vote_no_options", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4021, 139),
      ))
    }

@delegate:ResourceContentHash(1_782_867_650)
internal val Res.string.dot_vote_point_single: StringResource by lazy {
      StringResource("string:dot_vote_point_single", "dot_vote_point_single", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4161, 41),
      ))
    }

@delegate:ResourceContentHash(-1_045_247_613)
internal val Res.string.dot_vote_points: StringResource by lazy {
      StringResource("string:dot_vote_points", "dot_vote_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4203, 39),
      ))
    }

@delegate:ResourceContentHash(-1_310_555_655)
internal val Res.string.dot_vote_prompt: StringResource by lazy {
      StringResource("string:dot_vote_prompt", "dot_vote_prompt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4243, 91),
      ))
    }

@delegate:ResourceContentHash(259_574_257)
internal val Res.string.dot_vote_remaining: StringResource by lazy {
      StringResource("string:dot_vote_remaining", "dot_vote_remaining", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4335, 62),
      ))
    }

@delegate:ResourceContentHash(2_077_803_712)
internal val Res.string.dot_vote_remove: StringResource by lazy {
      StringResource("string:dot_vote_remove", "dot_vote_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4398, 63),
      ))
    }

@delegate:ResourceContentHash(948_422_657)
internal val Res.string.dot_voting_budget_label: StringResource by lazy {
      StringResource("string:dot_voting_budget_label", "dot_voting_budget_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4462, 55),
      ))
    }

@delegate:ResourceContentHash(1_244_715_289)
internal val Res.string.dot_voting_source_label: StringResource by lazy {
      StringResource("string:dot_voting_source_label", "dot_voting_source_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4518, 51),
      ))
    }

@delegate:ResourceContentHash(-342_768_435)
internal val Res.string.dot_voting_source_missing: StringResource by lazy {
      StringResource("string:dot_voting_source_missing", "dot_voting_source_missing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4570, 157),
      ))
    }

@delegate:ResourceContentHash(-383_822_666)
internal val Res.string.dot_voting_source_option: StringResource by lazy {
      StringResource("string:dot_voting_source_option", "dot_voting_source_option", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4728, 56),
      ))
    }

@delegate:ResourceContentHash(602_879_818)
internal val Res.string.download_markdown_action: StringResource by lazy {
      StringResource("string:download_markdown_action", "download_markdown_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4785, 76),
      ))
    }

@delegate:ResourceContentHash(-1_588_980_344)
internal val Res.string.download_markdown_dialog_action: StringResource by lazy {
      StringResource("string:download_markdown_dialog_action", "download_markdown_dialog_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4862, 51),
      ))
    }

@delegate:ResourceContentHash(234_892_080)
internal val Res.string.edit_answer_action: StringResource by lazy {
      StringResource("string:edit_answer_action", "edit_answer_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4914, 42),
      ))
    }

@delegate:ResourceContentHash(1_540_971_869)
internal val Res.string.error_action_rejected: StringResource by lazy {
      StringResource("string:error_action_rejected", "error_action_rejected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4957, 81),
      ))
    }

@delegate:ResourceContentHash(-614_189_855)
internal val Res.string.error_connection: StringResource by lazy {
      StringResource("string:error_connection", "error_connection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5039, 76),
      ))
    }

@delegate:ResourceContentHash(-342_382_098)
internal val Res.string.error_name_required: StringResource by lazy {
      StringResource("string:error_name_required", "error_name_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5116, 75),
      ))
    }

@delegate:ResourceContentHash(-2_012_722_106)
internal val Res.string.error_name_unavailable: StringResource by lazy {
      StringResource("string:error_name_unavailable", "error_name_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5192, 122),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("action_item_due", Res.string.action_item_due)
  map.put("action_item_what", Res.string.action_item_what)
  map.put("action_item_who", Res.string.action_item_who)
  map.put("add_question_action", Res.string.add_question_action)
  map.put("answer_choice_title", Res.string.answer_choice_title)
  map.put("answer_edit_label", Res.string.answer_edit_label)
  map.put("answer_label", Res.string.answer_label)
  map.put("answer_placeholder", Res.string.answer_placeholder)
  map.put("battery_answer_prompt", Res.string.battery_answer_prompt)
  map.put("battery_percent", Res.string.battery_percent)
  map.put("cancel_action", Res.string.cancel_action)
  map.put("category_abyss", Res.string.category_abyss)
  map.put("category_abyss_hint", Res.string.category_abyss_hint)
  map.put("category_add", Res.string.category_add)
  map.put("category_add_hint", Res.string.category_add_hint)
  map.put("category_anchor", Res.string.category_anchor)
  map.put("category_anchor_hint", Res.string.category_anchor_hint)
  map.put("category_answer_prompt", Res.string.category_answer_prompt)
  map.put("category_bridge", Res.string.category_bridge)
  map.put("category_bridge_hint", Res.string.category_bridge_hint)
  map.put("category_continue", Res.string.category_continue)
  map.put("category_continue_hint", Res.string.category_continue_hint)
  map.put("category_drop", Res.string.category_drop)
  map.put("category_drop_hint", Res.string.category_drop_hint)
  map.put("category_engine", Res.string.category_engine)
  map.put("category_engine_hint", Res.string.category_engine_hint)
  map.put("category_fire", Res.string.category_fire)
  map.put("category_fire_hint", Res.string.category_fire_hint)
  map.put("category_glad", Res.string.category_glad)
  map.put("category_glad_hint", Res.string.category_glad_hint)
  map.put("category_improve", Res.string.category_improve)
  map.put("category_improve_hint", Res.string.category_improve_hint)
  map.put("category_island", Res.string.category_island)
  map.put("category_island_hint", Res.string.category_island_hint)
  map.put("category_keep", Res.string.category_keep)
  map.put("category_keep_hint", Res.string.category_keep_hint)
  map.put("category_lacked", Res.string.category_lacked)
  map.put("category_lacked_hint", Res.string.category_lacked_hint)
  map.put("category_learned", Res.string.category_learned)
  map.put("category_learned_hint", Res.string.category_learned_hint)
  map.put("category_less", Res.string.category_less)
  map.put("category_less_hint", Res.string.category_less_hint)
  map.put("category_liked", Res.string.category_liked)
  map.put("category_liked_hint", Res.string.category_liked_hint)
  map.put("category_longed_for", Res.string.category_longed_for)
  map.put("category_longed_for_hint", Res.string.category_longed_for_hint)
  map.put("category_mad", Res.string.category_mad)
  map.put("category_mad_hint", Res.string.category_mad_hint)
  map.put("category_more", Res.string.category_more)
  map.put("category_more_hint", Res.string.category_more_hint)
  map.put("category_parachute", Res.string.category_parachute)
  map.put("category_parachute_hint", Res.string.category_parachute_hint)
  map.put("category_rock", Res.string.category_rock)
  map.put("category_rock_hint", Res.string.category_rock_hint)
  map.put("category_sad", Res.string.category_sad)
  map.put("category_sad_hint", Res.string.category_sad_hint)
  map.put("category_sandbag", Res.string.category_sandbag)
  map.put("category_sandbag_hint", Res.string.category_sandbag_hint)
  map.put("category_start", Res.string.category_start)
  map.put("category_start_hint", Res.string.category_start_hint)
  map.put("category_stop", Res.string.category_stop)
  map.put("category_stop_hint", Res.string.category_stop_hint)
  map.put("category_storm", Res.string.category_storm)
  map.put("category_storm_hint", Res.string.category_storm_hint)
  map.put("category_sun", Res.string.category_sun)
  map.put("category_sun_hint", Res.string.category_sun_hint)
  map.put("category_wind", Res.string.category_wind)
  map.put("category_wind_hint", Res.string.category_wind_hint)
  map.put("cluster_create", Res.string.cluster_create)
  map.put("cluster_delete", Res.string.cluster_delete)
  map.put("cluster_mode_done", Res.string.cluster_mode_done)
  map.put("cluster_mode_start", Res.string.cluster_mode_start)
  map.put("cluster_name_label", Res.string.cluster_name_label)
  map.put("cluster_selection_hint", Res.string.cluster_selection_hint)
  map.put("clusters_title", Res.string.clusters_title)
  map.put("create_retro_action", Res.string.create_retro_action)
  map.put("current_timer_label", Res.string.current_timer_label)
  map.put("current_timer_supporting_text", Res.string.current_timer_supporting_text)
  map.put("delete_answer_action", Res.string.delete_answer_action)
  map.put("display_name_label", Res.string.display_name_label)
  map.put("display_name_placeholder", Res.string.display_name_placeholder)
  map.put("dot_vote_add", Res.string.dot_vote_add)
  map.put("dot_vote_members", Res.string.dot_vote_members)
  map.put("dot_vote_no_options", Res.string.dot_vote_no_options)
  map.put("dot_vote_point_single", Res.string.dot_vote_point_single)
  map.put("dot_vote_points", Res.string.dot_vote_points)
  map.put("dot_vote_prompt", Res.string.dot_vote_prompt)
  map.put("dot_vote_remaining", Res.string.dot_vote_remaining)
  map.put("dot_vote_remove", Res.string.dot_vote_remove)
  map.put("dot_voting_budget_label", Res.string.dot_voting_budget_label)
  map.put("dot_voting_source_label", Res.string.dot_voting_source_label)
  map.put("dot_voting_source_missing", Res.string.dot_voting_source_missing)
  map.put("dot_voting_source_option", Res.string.dot_voting_source_option)
  map.put("download_markdown_action", Res.string.download_markdown_action)
  map.put("download_markdown_dialog_action", Res.string.download_markdown_dialog_action)
  map.put("edit_answer_action", Res.string.edit_answer_action)
  map.put("error_action_rejected", Res.string.error_action_rejected)
  map.put("error_connection", Res.string.error_connection)
  map.put("error_name_required", Res.string.error_name_required)
  map.put("error_name_unavailable", Res.string.error_name_unavailable)
}
